import React from 'react'
import { GroupsView } from 'src/components/GroupsView'
import { useLazyGetCarePartnerGroupsQuery } from 'src/store/APIs/carePartners'

interface GroupsProps {}

export const Groups: React.FC<GroupsProps> = () => (
  <GroupsView useLazyQuery={useLazyGetCarePartnerGroupsQuery} />
)
